import {
	Button,
	Card,
	Checkbox,
	Col,
	DatePicker,
	Form,
	Input,
	InputNumber,
	notification,
	Row,
	Select,
	Space,
	Tabs,
	Tooltip,
	Typography,
	Upload
} from "antd";
import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

import { InboxOutlined, InfoCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import { loadAllEmploymentStatus } from "../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { loadAllLeavePolicy } from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { loadAllSalaryComponents } from "../../redux/rtk/features/salaryComponent/salaryComponentSlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";
import { addStaff, getCompanyNameByClientId, loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import { statesData } from "../../utils/states";
import { getDepartments } from "../department/departmentApis";
import { getRoles } from "../role/roleApis";
import EmployeeEducationForm from "./EmployeeEducationForm";


const { TabPane } = Tabs;
const { Option } = Select;
const { Dragger } = Upload;
const { Title } = Typography;


const AddUser = () => {
	const [loader, setLoader] = useState(false);
	const [currentTab, setCurrentTab] = useState('1');
	const [enabledTabs, setEnabledTabs] = useState(["1"]);
	const dispatch = useDispatch();
	const { Title } = Typography;
	const { Option } = Select;
	const [list, setList] = useState(null);
	const [department, setDepartment] = useState(null);
	const [ctc, setCtc] = useState(0);
	const [inHandSalary, setInHandSalary] = useState(0);
	const [salaryData, setSalaryData] = useState({ ctc: 0, inHandSalary: 0 });
	const [salary, setSalary] = useState(0);
	const users = useSelector((state) => state.users?.list);
	const [imagePreview, setImagePreview] = useState(null);
	const [boxSize, setBoxSize] = useState({ width: 100, height: 100 }); // Initial size
	console.log("users", users);
	const [isTabValid, setIsTabValid] = useState([true, false, false, false, false, false, false, false, false]);


	const [education, setEducation] = useState([
		{
			degree: "",
			institution: "",
			fieldOfStudy: "",
			result: "",
			startDate: "",
			endDate: "",
		},
	]);
	const [thumbFileList, setThumbFileList] = useState([]);
	const [isMarried, setIsMarried] = useState(false);


	// useseletor to get designations from redux
	const designation = useSelector((state) => state.designations?.list);
	const officeName = useSelector((state) => state.users?.companyName);
	const employmentStatus = useSelector((state) => state.employmentStatus?.list);
	const shift = useSelector((state) => state.shift?.list);
	const weeklyHoliday = useSelector((state) => state.weeklyHoliday?.list);
	const leavePolicy = useSelector((state) => state.leavePolicy?.list);
	const salaryComponentData = useSelector((state) => state.salaryComponents?.list);

	// console.log("salaryComponentData", salaryComponentData)

	const [joiningDate, setJoiningDate] = useState({ date: null });
	const [probationPeriod, setProbationPeriod] = useState({ date: null });
	const [salaryStartDate, setSalaryStartDate] = useState({ date: null });
	const [designationStartDate, setDesignationStartDate] = useState({ date: null });
	const [birthdayDate, setBirthdayDate] = useState({ date: null });
	const [birthAnniversaryDate, setBirthAnniversaryDate] = useState({ date: null });


	const dateJoinFormatted = joiningDate.date ? joiningDate.date : null;
	const dateProbationPeriod = probationPeriod.date ? probationPeriod.date : null;

	const dateSalaryFormatted = salaryStartDate.date ? salaryStartDate.date : null;
	const dateDesignationFormatted = designationStartDate.date ? designationStartDate.date : null;
	const birthdayFormatted = birthdayDate.date ? birthdayDate.date : null;
	const birthAnniversaryFormatted = birthAnniversaryDate.date ? birthAnniversaryDate.date : null;


	const [selectedImage, setSelectedImage] = useState(null);
	const [selectedDocument, setSelectedDocument] = useState(null);

	const companyNames = useSelector((state) => state.user?.user);
	console.log("companyNames", companyNames);

	const companyId = getCompanyIdFromToken();
	console.log("companyId", companyId);
	// Dispatch action to fetch company names
	useEffect(() => {
		dispatch(getCompanyNameByClientId(companyId));
	}, [dispatch]);

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, []);

	// const handleFileUpload = ({ fileList }) => {
	// 	console.log("fileList", fileList);
	// 	setThumbFileList(fileList);
	// };

	useEffect(() => {
		getRoles()
			.then((d) => setList(d))
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		getDepartments()
			.then((d) => setDepartment(d))
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		dispatch(loadAllDesignation());
		dispatch(loadAllEmploymentStatus());
		dispatch(loadAllShift());
		dispatch(loadAllWeeklyHoliday());
		dispatch(loadAllLeavePolicy());
		dispatch(loadAllSalaryComponents());
	}, []);

	const [form] = Form.useForm();

	const validateUniqueUserName = (_, value) => {
		if (users.some(user => user.userName === value)) {
			return Promise.reject(new Error('This username is already taken.'));
		}
		return Promise.resolve();
	};

	const validateUniqueEmail = (_, value) => {
		if (users.some(user => user.email === value)) {
			return Promise.reject(new Error('This email is already in use.'));
		}
		return Promise.resolve();
	};

	const calculateTotals = () => {
		const salaryComponents = {};

		// Iterate over salary component data and fetch values from the form
		salaryComponentData.forEach(component => {
			const componentName = component.componentName;
			let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);

			// Check if the calculation type is '% of Basic'
			if (component.calculationType === '% of Basic') {
				const basicSalary = form.getFieldValue('salaryComponents.Basic');
				fieldValue = (fieldValue || 0) * (basicSalary || 0) / 100; // Calculate the percentage of Basic
			}

			salaryComponents[componentName] = fieldValue || 0;

			const amountFieldName = `${componentName}Amount`;
			form.setFieldsValue({
				[`salaryComponents.${amountFieldName}`]: fieldValue || 0
			});
		});

		const incomeComponents = salaryComponentData
			?.filter(component => component.componentType === 'Income')
			.map(component => salaryComponents[component.componentName] || 0);

		const deductionComponents = salaryComponentData
			?.filter(component => component.componentType === 'Deduction')
			.map(component => salaryComponents[component.componentName] || 0);

		const totalIncome = incomeComponents.reduce((acc, curr) => acc + curr, 0);
		const totalDeductions = deductionComponents.reduce((acc, curr) => acc + curr, 0);

		setSalaryData({
			ctc: totalIncome,
			inHandSalary: totalIncome - totalDeductions
		});

		setSalary(salaryData.inHandSalary)

		// Update form fields with new salaryData values
		form.setFieldsValue({
			ctc: totalIncome,
			inHandSalary: totalIncome - totalDeductions,
		});
	};



	const handleFileUpload = (info, fieldKey) => {
		console.log("lala", info)
		console.log("land", fieldKey)
		const fileList = [...info.fileList].slice(-1); // Keep only the latest file
		form.setFields([{
			name: ['documents', fieldKey, 'file'],
			value: fileList
		}]);
		setThumbFileList(info.fileList)
		if (info.fileList.length > 0) {
			setSelectedDocument(info.fileList[0].originFileObj)
		}
	};



	const onFinish = async (values) => {

		const salaryComponents = {};
		salaryComponentData.forEach(component => {
			const componentId = component.id;
			const componentName = component.componentName;
			let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);
			salaryComponents[componentId] = fieldValue;
		});

		console.log("Bir, ann", birthdayFormatted, birthAnniversaryFormatted);
		

		const FormData = {
			...values,
			dateJoinFormatted,
			dateProbationPeriod,
			dateSalaryFormatted,
			dateDesignationFormatted,
			salaryComponents,
			birthdayFormatted,
			birthAnniversaryFormatted,
			educations: values.educations || education,
			documents: values.documents || document,
			salary: salary || 0,
			file: thumbFileList[0]?.originFileObj,
		};

		console.log("FormData", FormData);
		console.log("File object:", thumbFileList[0]?.originFileObj);
		setLoader(true);

		try {
			values.phone = `+91${values.phone}`;
			const resp = await dispatch(addStaff(FormData));
			setLoader(true);

			if (resp.payload.message === "success") {
				// form.resetFields();
				setLoader(false);
			} else if (resp.payload.message === "error") {
				setLoader(false);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.log(error.message);
			setLoader(false);
		}
	};




	const onFinishFailed = (errorInfo) => {
		setLoader(false);
		console.log("Failed:", errorInfo);
		// message.error("Please fill out all required fields!");
		notification.error({
			message: 'Submission Error',
			description: 'Please ensure all required fields are filled out before submitting.',
		});
	};


	const handleNext = async () => {
		try {
			let fieldsToValidate = [];
			switch (currentTab) {
				case '1':
					fieldsToValidate = ['firstName', 'lastName', 'userName', 'password', 'fatherName', 'birthdate', 'birthAnniversary', 'marriageAnniversary', 'gender', 'pan', 'aadhar'];
					break;
				case '2':
					fieldsToValidate = ['phone'];
					break;
				case '3':
					fieldsToValidate = ['street', 'city', 'state', 'zipCode', 'country', 'pAddress', 'pCity', 'pState', 'pZipCode', 'pCountry'];
					break;
				case '4':
					fieldsToValidate = ['joinDate', 'employeeId', 'employmentStatusId', 'esic', 'reportingManagerId', 'departmentId', 'roleId', 'shiftId', 'leavePolicyId', 'weeklyHolidayId', 'email', 'officialMailId', 'pfEligiblity', 'uan', 'paymentType'];
					break;
				case '5':
					fieldsToValidate = ['designationId', 'StartDate'];
					break;
				case '6':
					fieldsToValidate = ['startDate'];
					break;
				case '7':
					fieldsToValidate = ['accountHolderName', 'bankName', 'accountNumber', 'IFSC_code'];
					break;
				case '8':
					fieldsToValidate = ['pan', 'aadhar'];
					break;
				default:
					break;
			}

			await form.validateFields(fieldsToValidate);

			// Enable the next tab
			const nextTab = String(Number(currentTab) + 1);
			if (!enabledTabs.includes(nextTab)) {
				setEnabledTabs([...enabledTabs, nextTab]);
			}

			setCurrentTab(nextTab);
		} catch (errorInfo) {
			console.log('Validation Failed:', errorInfo);
		}
	};

	const handlePrevious = () => {
		const prevTab = String(Number(currentTab) - 1);
		setCurrentTab(prevTab);
	};

	const isTabDisabled = (tabKey) => {
		return !enabledTabs.includes(tabKey);
	};



	const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"]; // blood groups

	return (
		<Fragment bordered={false}>
			<UserPrivateComponent permission={"create-user"}>
				<div className='mr-top mt-5 p-5 ant-card ' style={{ maxWidth: "100%" }}>
					<Form
						size='small'
						form={form}
						name='basic'
						labelCol={{
							span: 10,
						}}
						wrapperCol={{
							span: 22,
						}}
						initialValues={{
							remember: true,
							salaryComponents: {},
							country: 'India',
							pCountry: 'India'
						}}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete='off'
						onValuesChange={calculateTotals}
					>


						<Tabs activeKey={currentTab} onChange={setCurrentTab}>
							<TabPane tab="User Information" key="1" disabled={isTabDisabled("1")}>

								<Col span={24} className='gutter-row form-color'>
									<Row gutter={[16, 16]}>

										<Col span={12}>
											<Form.Item
												style={{ marginBottom: "10px" }}
												label='First Name'
												name='firstName'
												rules={[
													{ required: true, message: "Please input First Name!" },
												]}
											>
												<Input placeholder='First Name' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='User Name'
												name='userName'
												rules={[
													{ required: true, message: "Please input User Name!" },
													{ validator: validateUniqueUserName },
												]}
											>
												<Input placeholder='User Name' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label="Father's Name"
												name='fatherName'
												rules={[
													{ required: true, message: "Please input Father's Name!" },
												]}
											>
												<Input placeholder="Father's Name" />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label={<span>Birthdate
													<Tooltip title="As Per Document">
														<InfoCircleOutlined style={{ marginLeft: "5px" }} />
													</Tooltip>
												</span>}

												name='birthdate'
												rules={[
													{ required: true, message: "Please input Birthdate!" },
												]}

											>
												<DatePicker
													format='DD-MM-YYYY'
													placeholder='Select Birthdate'
													style={{ width: '100%' }}
													onChange={(date, dateString) => {
														setBirthdayDate({ date: dateString });
														console.log("Birthday Date:", birthdayDate);
													}}
												/>
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label="Gender"
												name="gender"
												rules={[
													{ required: true, message: "Please select your gender!" },
												]}
											>
												<Select placeholder="Select Gender" showSearch allowClear mode="combobox">
													<Select.Option value="male">Male</Select.Option>
													<Select.Option value="female">Female</Select.Option>
													<Select.Option value="other">Other</Select.Option>
												</Select>
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='PAN Card Number'
												name='pan'
												rules={[
													{ required: true, message: "Please input PAN Card Number!" },
												]}
											>
												<Input placeholder='PAN Card Number' />
											</Form.Item>
										</Col>

										{/* Second Column */}
										<Col span={12}>
											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Last Name'
												name='lastName'
												rules={[
													{ required: true, message: "Please input Last Name!" },
												]}
											>
												<Input placeholder='Last Name' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Password'
												name='password'
												rules={[
													{ required: true, message: "Please input your password!" },
												]}
											>
												<Input placeholder='Password' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label={<span>Birth Anniversary
													<Tooltip title="Original Date of Birth">
														<InfoCircleOutlined style={{ marginLeft: "5px" }} />
													</Tooltip>
												</span>}
												name='birthAnniversary'
												rules={[
													{ required: true, message: "Please input Birth Anniversary!" },
												]}
											>
												<DatePicker
													format='DD-MM-YYYY'
													placeholder='Select Birth Anniversary'
													style={{ width: '100%' }}
													onChange={(date, dateString) => {
														setBirthAnniversaryDate({ date: dateString });
														console.log("Birthday Date:", birthAnniversaryDate);
													}}
												/>
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label="Marital Status"
												name="maritalStatus"
												rules={[
													{ required: true, message: "Please select your marital status!" },
												]}
											>
												<Select
													placeholder="Select Marital Status"
													showSearch
													allowClear
													mode="combobox"
													onChange={(value) => {
														setIsMarried(value === 'married'); // Update state based on selected value
													}}
												>
													<Select.Option value="single">Single</Select.Option>
													<Select.Option value="married">Married</Select.Option>
												</Select>
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Blood Group'
												name='bloodGroup'

											>
												<Select
													placeholder='Select Blood Group'
													showSearch allowClear mode="combobox"
													size='middle'
													style={{ width: "100%" }}
												>
													{bloodGroups.map((bloodGroup) => (
														<Select.Option key={bloodGroup} value={bloodGroup}>
															{bloodGroup}
														</Select.Option>
													))}
												</Select>
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Aadhar Card Number'
												name='aadhar'
												rules={[
													{ required: true, message: "Please input Aadhar Card Number!" },
												]}
											>
												<Input placeholder='Aadhar Card Number' />
											</Form.Item>
										</Col>
									</Row>
								</Col>
							</TabPane>

							<TabPane tab="Contact Details" key="2" disabled={isTabDisabled("2")}>

								<Col span={12} className='gutter-row'>
									<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
										Contact Details
									</h2>
									<Form.Item
										style={{ marginBottom: "10px" }}
										label="Phone"
										name="phone"
										rules={[
											{
												required: true,
												message: "Please input phone number!",
											},
											{
												pattern: /^[0-9]{10}$/,
												message: "Please enter a valid 10-digit phone number!",
											},
										]}
									>
										<Input placeholder="Phone" maxLength={10} addonBefore="+91" />
									</Form.Item>
									<Form.Item
										style={{ marginBottom: "10px" }}
										label="Alternate Number"
										name="alternateNumber"
										rules={[

											{
												pattern: /^[0-9]{10}$/,
												message: "Please enter a valid 10-digit Emergency Contact Number!",
											},
										]}
									>
										<Input placeholder="Phone" maxLength={10} addonBefore="+91" />
									</Form.Item>
									<Form.Item
										style={{ marginBottom: "10px" }}
										label="Emergency Contact Number"
										name="emergencyContactNumber"
										rules={[

											{
												pattern: /^[0-9]{10}$/,
												message: "Please enter a valid 10-digit Emergency Contact Number!",
											},
										]}
									>
										<Input placeholder="Phone" maxLength={10} addonBefore="+91" />
									</Form.Item>
									<Form.Item
										style={{ marginBottom: "10px" }}
										label="Emergency Contact Person"
										name="contactPersonName"

									>
										<Input placeholder="Contact Person Name" />
									</Form.Item>
									<Form.Item
										style={{ marginBottom: "10px" }}
										label="Contact Person Relation"
										name="contactPersonRelation"

									>
										<Select
											placeholder="Select or type relation"
											showSearch
											allowClear
											mode="combobox"
										>
											<Select.Option value="Father">Father</Select.Option>
											<Select.Option value="Mother">Mother</Select.Option>
											<Select.Option value="Brother">Brother</Select.Option>
											<Select.Option value="Sister">Sister</Select.Option>
											<Select.Option value="Friend">Friend</Select.Option>
											<Select.Option value="Spouse">Spouse</Select.Option>
											<Select.Option value="Other">Other</Select.Option>

										</Select>
									</Form.Item>
								</Col>
							</TabPane>

							<TabPane tab="Address Information" key="3" disabled={isTabDisabled("3")}>
								<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
									Address Information
								</h2>

								<Row gutter={24}>
									<Col span={12}>
										<Card title="Current Address" bordered={true} style={{ height: '100%' }}>
											<Form.Item
												label='House Address'
												name='street'
												rules={[{ required: true, message: "Please input house address!" }]}
											>
												<Input placeholder='Enter Address' />
											</Form.Item>

											<Form.Item
												label='City'
												name='city'
												rules={[{ required: true, message: "Please input city!" }]}
											>
												<Input placeholder='City' />
											</Form.Item>

											<Form.Item
												label='State'
												name='state'
												rules={[{ required: true, message: "Please select a state!" }]}
											>
												<Select placeholder="Select a state" showSearch allowClear>
													{statesData.states.map((state) => (
														<Select.Option key={state} value={state}>
															{state}
														</Select.Option>
													))}
												</Select>
											</Form.Item>

											<Form.Item
												label='Zip Code'
												name='zipCode'
												rules={[
													{ required: true, message: "Please input Zip Code!" },
													{ pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit Zip Code!" },
												]}
											>
												<Input placeholder="000000" maxLength={6} />
											</Form.Item>

											<Form.Item
												label='Country'
												name='country'
												rules={[{ required: true, message: "Please input Country!" }]}
											>
												<Input placeholder='Bharat' disabled />
											</Form.Item>
										</Card>
									</Col>

									<Col span={12}>
										<Card title="Permanent Address" bordered={true} style={{ height: '100%' }}>
											<Form.Item
												label='House Address'
												name='pAddress'
												rules={[{ required: true, message: "Please input house address!" }]}
											>
												<Input placeholder='Enter Address' />
											</Form.Item>

											<Form.Item
												label='City'
												name='pCity'
												rules={[{ required: true, message: "Please input city!" }]}
											>
												<Input placeholder='City' />
											</Form.Item>

											<Form.Item
												label='State'
												name='pState'
												rules={[{ required: true, message: "Please select a state!" }]}
											>
												<Select placeholder="Select a state" showSearch allowClear>
													{statesData.states.map((state) => (
														<Select.Option key={state} value={state}>
															{state}
														</Select.Option>
													))}
												</Select>
											</Form.Item>

											<Form.Item
												label='Zip Code'
												name='pZipCode'
												rules={[
													{ required: true, message: "Please input Zip Code!" },
													{ pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit Zip Code!" },
												]}
											>
												<Input placeholder="000000" maxLength={6} />
											</Form.Item>

											<Form.Item
												label='Country'
												name='pCountry'
												rules={[{ required: true, message: "Please input Country!" }]}
											>
												<Input placeholder='Bharat' disabled />
											</Form.Item>
										</Card>
									</Col>
								</Row>

								<Row justify="center" style={{ marginTop: '20px' }}>
									<Col>
										<Form.Item>
											<Checkbox
												onChange={(e) => {
													if (e.target.checked) {
														form.setFieldsValue({
															pAddress: form.getFieldValue('street'),
															pCity: form.getFieldValue('city'),
															pState: form.getFieldValue('state'),
															pZipCode: form.getFieldValue('zipCode'),
															pCountry: form.getFieldValue('country'),
														});
													} else {
														form.setFieldsValue({
															pAddress: '',
															pCity: '',
															pState: '',
															pZipCode: '',
															pCountry: '',
														});
													}
												}}
											>
												Current address and permanent address are the same
											</Checkbox>
										</Form.Item>
									</Col>
								</Row>
							</TabPane>

							<TabPane tab="Employee Information" key="4" disabled={isTabDisabled("4")}>
								<Col span={24} className='gutter-row form-color'>
									<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
										Employee Information
									</h2>

									<Row gutter={[16, 16]}>
										{/* First Column */}
										<Col span={12}>
											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Joining Date'
												name='joinDate'
												rules={[
													{
														required: true,
														message: "Please input joining date!",
													},
													({ getFieldValue }) => ({
														validator(_, value) {
															const joinDate = getFieldValue('joinDate');
															if (!value || !joinDate) {
																return Promise.resolve();
															}
															if (value.unix() >= joinDate.unix()) {
																return Promise.resolve();
															}
															return Promise.reject(
																new Error("Probation period end date must be after or equal to the joining date!")
															);
														},
													}),
												]}>
												<DatePicker className='date-picker hr-staffs-date-picker'

													// onChange={(date, dateString) => {
													// 	setJoiningDate(dateString); // Store joining date
													// 	form.validateFields(['probationPeriod', 'startDate', 'StartDate']); // Trigger validation for dependent fields
													// }}
													
													onChange={(date, dateString) => {
														if (date) {
															const joinDate = date.startOf('day'); // Sets the time to 00:00:00
															setJoiningDate({ date: dateString });
															console.log("joiningDate",joiningDate);
															console.log("joiningDate", { date: dateString });
														} else {
															setJoiningDate(null); // Handle case where date is cleared
														}
														// setJoinDate(date);
														form.validateFields(['probationPeriod', 'startDate', 'StartDate']);
													}}
													format="DD-MM-YYYY"
													inputReadOnly
												/>
											</Form.Item>



											{/* TODO: Add an Upload Section for Image */}

											<Form.Item
												name={"employmentStatusId"}
												style={{ marginBottom: "10px" }}
												rules={[
													{
														required: true,
														message: "Please Select Employment Status!",
													},
												]}
												label='Employee Status'>
												<Select
													placeholder='Select Status'
													showSearch allowClear mode="combobox"
													size={"middle"}
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}>
													{employmentStatus &&
														employmentStatus.map((employmentStatus) => (
															<Select.Option
																key={employmentStatus.id}
																value={employmentStatus.id}>
																{employmentStatus.name}
															</Select.Option>
														))}
												</Select>
											</Form.Item>
											<Form.Item
												name={"departmentId"}
												style={{ marginBottom: "10px" }}
												label='Department'
												rules={[
													{ required: true, message: "Please Select Department!" },
												]}>
												<Select
													loading={!department}
													placeholder='Select Department'
													showSearch allowClear mode="combobox"
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}
													size={"middle"}>
													{department &&
														department.map((department) => (
															<Select.Option key={department.id} value={department.id}>
																{department.name}
															</Select.Option>
														))}
												</Select>
											</Form.Item>
											<Form.Item
												rules={[
													{ required: true, message: "Please Select User Role!" },
												]}
												label='Role'
												name={"roleId"}
												style={{ marginBottom: "10px" }}
											>
												<Select
													loading={!list}
													size='middle'
													mode='combobox'
													allowClear
													showSearch
													style={{
														width: "100%",
													}}
													placeholder='Please select'
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}
												>
													{list &&
														list.map((role) => (
															<Select.Option key={role.id} value={role.id}>
																{role.name}
															</Select.Option>
														))}
												</Select>
											</Form.Item>
											{/* <Form.Item
												rules={[
													{ required: true, message: "Please Select Leave Policy!" },
												]}
												label='Leave Policy'
												name={"leavePolicyId"}
												style={{ marginBottom: "10px" }}>
												<Select
													loading={!leavePolicy}
													size='middle'
													showSearch allowClear mode="combobox"


													style={{
														width: "100%",
													}}
													placeholder='Please select'>
													{leavePolicy &&
														leavePolicy.map((leavePolicy) => (
															<Option key={leavePolicy.id} value={leavePolicy.id}>
																{leavePolicy.name}
															</Option>
														))}
												</Select>
											</Form.Item> */}
											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Email'
												name='email'
												rules={[
													{ required: true, message: "Please input email!" },
													{ type: 'email', message: "Please enter a valid email!" },
													{ validator: validateUniqueEmail },
												]}
											>
												<Input placeholder='Email' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label="PF Eligibility"
												name="pfEligiblity"
												rules={[
													{
														required: true,
														message: "Please select PF eligibility!",
													},
												]}
											>
												<Select
													placeholder="Select PF eligibility"
													showSearch
													allowClear
													mode="combobox"
												>
													<Select.Option value="yes">Yes</Select.Option>
													<Select.Option value="no">No</Select.Option>
												</Select>
											</Form.Item>


											{/* Payment Type Field */}
											<Form.Item
												style={{ marginBottom: "10px" }}
												label="Payment Type"
												name="paymentType"
												rules={[{ required: true, message: "Please select Payment Type!" }]}
											>
												<Select
													placeholder="Select Payment Type"
													showSearch
													allowClear
													mode="combobox"
												>
													<Select.Option value="bankTransfer">Bank Transfer</Select.Option>
													<Select.Option value="cheque">Cheque</Select.Option>
													<Select.Option value="cash">Cash</Select.Option>
													<Select.Option value="other">Other</Select.Option>
												</Select>
											</Form.Item>

											<Form.Item
												name="CompanyOfficeId"
												style={{ marginBottom: "10px" }}
												label="Office"
												rules={[
													{ required: true, message: "Please Select Office!" },
												]}

											>
												<Select
													loading={!officeName}
													placeholder="Select Office"
													showSearch
													allowClear
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}
													size="middle"
												>
													{officeName &&
														officeName.map((office) => (
															<Select.Option key={office.id} value={office.id}>
																{office.company_name}
															</Select.Option>
														))}
												</Select>
											</Form.Item>

										</Col>
										<Col span={12}>
											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Employee ID'
												name='employeeId'
												rules={[
													{
														required: true,
														message: "Please input Employee ID!",
													},
												]}>
												<Input placeholder='Emp-001' />
											</Form.Item>
											<Form.Item
												style={{ marginBottom: "10px" }}
												label='ESIC'
												name='esic'
											// rules={[
											// 	{ required: true, message: "Please input ESIC!" },

											// ]}
											>
												<Input placeholder='ESIC' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label="Reporting Manager "
												name="reportingManagerId"
												rules={[
													{
														required: true,
														message: "Please select a user!",
													},
												]}
											>
												<Select
													placeholder="Reporting Manager"
													showSearch
													allowClear
													filterOption={(input, option) =>
														option.label.toLowerCase().includes(input.toLowerCase())
													}
												>
													{users.map(user => (
														<Select.Option
															key={user.id}
															value={user.id}
															label={`${user.firstName} ${user.lastName}`}
														>
															{user.firstName} {user.lastName}
														</Select.Option>
													))}
												</Select>

											</Form.Item>

											<Form.Item
												rules={[
													{ required: true, message: "Please Select User Shift!" },
												]}
												label='Shift'
												name={"shiftId"}
												style={{ marginBottom: "10px" }}>
												<Select
													loading={!shift}
													size='middle'
													showSearch allowClear
													style={{
														width: "100%",
													}}
													placeholder='Please select'
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}
												>
													{shift &&
														shift.map((shift) => (
															<Select.Option key={shift.id} value={shift.id}>
																{shift.name}
															</Select.Option>
														))}
												</Select>
											</Form.Item>

											<Form.Item
												rules={[
													{ required: true, message: "Please Select Weekly Roaster!" },
												]}
												label='Weekly Holiday'
												showSearch allowClear mode="combobox"
												name={"weeklyHolidayId"}
												style={{ marginBottom: "10px" }}>
												<Select
													loading={!weeklyHoliday}
													size='middle'
													showSearch allowClear

													style={{
														width: "100%",
													}}
													placeholder='Please select'
													filterOption={(input, option) =>
														String(option.children).toLowerCase().includes(input.toLowerCase())
													}
												>
													{weeklyHoliday &&
														weeklyHoliday.map((weeklyHoliday) => (
															<Select.Option key={weeklyHoliday.id} value={weeklyHoliday.id}>
																{weeklyHoliday.name}
															</Select.Option>
														))}
												</Select>
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='Official Email'
												name='officialMailId'
												rules={[
													{ required: true, message: "Please input Official email!" },
													{ type: 'email', message: "Please enter a valid Official email!" },
													{ validator: validateUniqueEmail },
												]}
											>
												<Input placeholder='Email' />
											</Form.Item>

											<Form.Item
												style={{ marginBottom: "10px" }}
												label='UAN'
												name='uan'
												rules={[
													// { required: true, message: "Please input UAN!" },
													{ pattern: /^[0-9]{12}$/, message: "Please enter a valid 12-digit UAN!" }
												]}
											>
												<Input placeholder='Enter UAN' maxLength={12} />
											</Form.Item>
											<Form.Item
												style={{ marginBottom: "10px" }}
												label=' Probation Period'
												name=' probationPeriod '
												rules={[
													({ getFieldValue }) => ({
														validator(_, value) {
															const joinDate = getFieldValue('joinDate');
															if (!value || !joinDate || value.isAfter(joinDate)) {
																return Promise.resolve();
															}
															return Promise.reject(
																new Error("Probation date must be After the joining date!")
															);
														},
													}),
												]}
											>

												<DatePicker className='date-picker hr-staffs-date-picker'
													onChange={(date, dateString) =>
														setProbationPeriod({ date: dateString })
													}
													// onChange={(date) => {
													// 	setProbationPeriod({ date });
													// }}
													format="DD-MM-YYYY"
													inputReadOnly
												/>
											</Form.Item>

										</Col>
									</Row>
								</Col>
							</TabPane>

							<TabPane tab="Designation Information" key="5" disabled={isTabDisabled("5")}>
								<Col span={12} className='gutter-row'>
									<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
										Designation Information
									</h2>

									<Form.Item
										rules={[
											{ required: true, message: "Please Select Designation!" },
										]}
										label='Designation'
										name={"designationId"}
										style={{ marginBottom: "10px" }}>
										<Select
											loading={!shift}
											size='middle'
											showSearch
											allowClear
											style={{
												width: "100%",
											}}
											placeholder='Please select Designation'
											filterOption={(input, option) =>
												String(option.children).toLowerCase().includes(input.toLowerCase())
											}>
											{designation &&
												designation.map((designation) => (
													<Select.Option key={designation.id} value={designation.id}>
														{designation.name}
													</Select.Option>
												))}
										</Select>
									</Form.Item>

									<Form.Item
										style={{ marginBottom: "10px" }}
										label='Start Date'
										name='StartDate'
										rules={[
											({ getFieldValue }) => ({
												validator(_, value) {
													const joinDate = getFieldValue('joinDate');
													if (!value || !joinDate) {
														return Promise.resolve();
													}
													if (value.unix() >= joinDate.unix()) {
														return Promise.resolve();
													}
													return Promise.reject(
														new Error("Start date must be after or equal to the joining date!")
													);
												},
											}),
										]}
									>
										<DatePicker className='date-picker hr-staffs-date-picker'
											// onChange={(date, dateString) => {
											// 	setDesignationStartDate({ date: dateString });
											// 	form.validateFields(['joinDate']);
											// }}
											onChange={(date, dateString) => {
												setDesignationStartDate({ date: dateString });
												console.log("designationDate", designationStartDate);
											}}											
											
											format="DD-MM-YYYY"
											inputReadOnly
										/>
									</Form.Item>

									{/* <Form.Item
										style={{ marginBottom: "10px" }}
										label='End Date'
										name='EndDate'>
										<DatePicker className='date-picker hr-staffs-date-picker' />
									</Form.Item> */}
								</Col>
							</TabPane>

							<TabPane tab="Salary Information" key="6" disabled={isTabDisabled("6")}>
								<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
									Salary Information
								</h2>
								<br />
								<Col span={12} className='gutter-row'>
									<Form.Item
										label='Salary Start Date'
										name='startDate'
										style={{ marginBottom: "10px" }}
										rules={[
											{
												required: true,
												message: "Please input Probation Period date!"
											},
											({ getFieldValue }) => ({
												validator(_, value) {
													const joinDate = getFieldValue('joinDate');
													if (!value || !joinDate) {
														return Promise.resolve();
													}
													if (value.unix() >= joinDate.unix()) {
														return Promise.resolve();
													}
													return Promise.reject(
														new Error("Probation period end date must be after or equal to the joining date!")
													);
												},
											}),
										]}
									>
										<DatePicker className='date-picker hr-staffs-date-picker'
											// onChange={(date, dateString) => {
											// 	setSalaryStartDate({ date: dateString });
											// 	form.validateFields(['joinDate']);
											// }}
											onChange={(date, dateString) => {
												setSalaryStartDate({ date: dateString });
												form.validateFields(['joinDate']);
											}}
											format="DD-MM-YYYY"
											inputReadOnly
										/>
									</Form.Item>
								</Col>
								<hr />
								<br />

								<Row gutter={24}>
									<Col span={12}>
										<h3 className='text-center text-xl mt-3 mb-3 txt-color'>
											Income
										</h3>
										{salaryComponentData
											?.filter(component => component.componentType === 'Income')
											.map((component, index) => (
												<Form.Item
													key={index}
													style={{ marginBottom: '10px' }}
													label={component.componentName}
													name={`salaryComponents.${component.componentName}`}
												// rules={[
												// 	{
												// 		required: true,
												// 		message: `Please input ${component.componentName}!`,
												// 	},
												// ]}>
												>
													<InputNumber
														min={0}
														step={0.01}
														style={{ width: '100%' }}
														placeholder={component.componentName}
														addonAfter={component.calculationType === '% of Basic' ? '% of Basic' : null}
													/>
												</Form.Item>
											))}

										<br />


									</Col>
									<Col span={12}>
										<h3 className='text-center text-xl mt-3 mb-3 txt-color'>
											Deduction
										</h3>
										{salaryComponentData
											?.filter(component => component.componentType === 'Deduction')
											.map((component, index) => (
												<Form.Item
													key={index}
													style={{ marginBottom: '10px' }}
													label={component.componentName}
													name={`salaryComponents.${component.componentName}`}
												// rules={[
												// 	{
												// 		required: true,
												// 		message: `Please input ${component.componentName}!`,
												// 	},
												// ]}>
												>
													<InputNumber
														min={0}
														step={0.01}
														style={{ width: '100%' }}
														placeholder={component.componentName}
														addonAfter={component.calculationType === '% of Basic' ? '% of Basic' : null}
													/>
												</Form.Item>
											))}

										<br />


									</Col>
								</Row>

								<hr />
								<br />
								<Row gutter={24}>
									<Col span={12}>
										{salaryComponentData
											?.filter(component => component.componentType === 'Income')
											.map((component, index) => {
												if (component.calculationType === '% of Basic') {
													return (
														<Form.Item
															key={index} // To provide a unique key for each mapped element
															style={{ marginBottom: '10px' }}
															label={`${component.componentName} Amount`}
															name={`salaryComponents.${component.componentName}Amount`}
															initialValue={0} // Initial value set to 0
														// rules={[
														// 	{
														// 		required: true,
														// 		message: `Please input ${component.componentName} Amount!`,
														// 	},
														// ]}
														>
															<InputNumber
																disabled // Disable input for calculated amounts
																style={{ width: '100%' }}
															/>
														</Form.Item>
													);
												} else {
													return null; // Return null for elements that don't match the condition
												}
											})
										}
									</Col>
									<Col span={12}>
										{salaryComponentData
											?.filter(component => component.componentType === 'Deduction')
											.map((component, index) => {
												if (component.calculationType === '% of Basic') {
													return (
														<Form.Item
															key={index}
															style={{ marginBottom: '10px' }}
															label={`${component.componentName} Amount`}
															name={`salaryComponents.${component.componentName}Amount`}
															initialValue={0}
														// rules={[
														// 	{
														// 		required: true,
														// 		message: `Please input ${component.componentName} Amount!`,
														// 	},
														// ]}
														>
															<InputNumber
																disabled
																style={{ width: '100%' }}
															/>
														</Form.Item>
													);
												} else {
													return null;
												}
											})
										}
									</Col>
								</Row>

								<hr />
								<br />
								<Row gutter={24}>
									<Col span={12}>
										<Form.Item
											label='CTC'
											name='ctc'
										>
											<InputNumber
												defaultValue={salaryData.ctc}
												readOnly
												style={{ width: '100%' }}
											/>
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											label='In Hand Salary'
											name='inHandSalary'
										>
											<InputNumber
												defaultValue={salaryData.inHandSalary}
												readOnly
												style={{ width: '100%' }}
											/>
										</Form.Item>
									</Col>
								</Row>

							</TabPane>

							<TabPane tab="Bank Details" key="7" disabled={isTabDisabled("7")}>
								<Col span={12} className='gutter-row form-color'>
									<h2 className='text-center text-xl mt-3 mb-3 txt-color'>
										Bank Details
									</h2>
									<Form.Item
										style={{ marginBottom: "10px" }}
										label='Account Holder Name'
										name='accountHolderName'
										rules={[
											{
												required: true,
												message: "Please input Account Holder Name!",
											},
										]}
									>
										<Input placeholder='Account Holder Name' />
									</Form.Item>

									<Form.Item
										style={{ marginBottom: "10px" }}
										label='Bank Name'
										name='bankName'
										rules={[
											{
												required: true,
												message: "Please input Bank Name!",
											},
										]}
									>
										<Input placeholder='Bank Name' />
									</Form.Item>

									<Form.Item
										style={{ marginBottom: "10px" }}
										label='Account Number'
										name='accountNumber'
										rules={[
											{
												required: true,
												message: "Please input Account Number!",
											},
											{
												pattern: /^[0-9]{9,18}$/,
												message: "Please enter a valid account number (9-18 digits)!",
											},
										]}
									>
										<Input placeholder='Account Number' maxLength={18} />
									</Form.Item>

									<Form.Item
										style={{ marginBottom: "10px" }}
										label='IFSC Code'
										name='IFSC_code'
										rules={[
											{
												required: true,
												message: "Please input IFSC Code!",
											},
											{
												pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
												message: "Please enter a valid IFSC code!",
											},
										]}
									>
										<Input placeholder='IFSC Code' />
									</Form.Item>

									<Form.Item
										style={{ marginBottom: "10px" }}
										label='Branch Name'
										name='branchName'
										rules={[
											{
												required: true,
												message: "Please input Branch Name!",
											},
										]}
									>
										<Input placeholder='Branch Name' />
									</Form.Item>
								</Col>
							</TabPane>
							<TabPane tab="Upload Document" key="8" disabled={isTabDisabled("8")}>
								<h2 className="text-center text-xl mt-3 mb-5 txt-color">Upload Document</h2>
								<div className="text-center">
									<p className="text-red-500 text-base mb-4">
										Please Upload Document using the button below
									</p>
								</div>

								<Form.List name="documents">
									{(fields, { add, remove }) => (
										<>
											{fields.map(({ key, name, formItemProps, fieldData }) => (
												<Space
													key={key}
													style={{
														display: "flex",
														justifyContent: "space-between",
														marginBottom: 8,
													}}
													align="baseline"
												>
													<Form.Item
														{...formItemProps}
														label="Document Type"
														name={[name, "documentName"]}
														rules={[{ required: true, message: "Please select the Document type!" }]}
													>
														<Select
															placeholder="Select Document Type"
															showSearch
															allowClear
															mode="combobox"
														>
															<Select.Option value="Aadhar">Aadhar</Select.Option>
															<Select.Option value="PAN">PAN</Select.Option>
															<Select.Option value="10th Certificate">10th Certificate</Select.Option>
															<Select.Option value="12th Certificate">12th Certificate</Select.Option>
															<Select.Option value="Other">Other</Select.Option>
														</Select>
													</Form.Item>

													<Form.Item
														noStyle
														shouldUpdate={(prevValues, currentValues) =>
															prevValues.documentName !== currentValues.documentName
														}
													>
														{({ getFieldValue }) =>
															getFieldValue([name, "documentName"]) === "Other" ? (
																<Form.Item
																	name={[name, "otherDocumentName"]}
																	label="Enter Document Type"
																	rules={[{ required: true, message: "Please enter the document type" }]}
																>
																	<Input placeholder="Enter document type" />
																</Form.Item>
															) : null
														}
													</Form.Item>

													<Form.Item
														style={{ marginBottom: "10px" }}
														label="Upload Document"
														required={false}
													>
														<Dragger
															listType="picture-card"
															beforeUpload={() => false}
															name="file"
															fileList={fieldData?.thumbFileList}
															onChange={(info) => handleFileUpload(info, key)}
															maxCount={1}
														>
															<p className="ant-upload-drag-icon">
																<InboxOutlined />
															</p>
															<p className="ant-upload-hint">
																Support for a single upload.
															</p>
														</Dragger>
													</Form.Item>

													<MinusCircleOutlined
														className="txt-color"
														style={{ fontSize: "150%" }}
														onClick={() => remove(name)}
													/>
												</Space>
											))}

											<Form.Item
												style={{ marginBottom: "10px" }}
												wrapperCol={{
													offset: 4,
													span: 16,
												}}
											>
												<Button
													type="dashed"
													size="middle"
													style={{ color: "#fff", backgroundColor: "#2c3e50" }}
													onClick={() => add()}
													block
													icon={<PlusOutlined />}
												>
													Add Document
												</Button>
											</Form.Item>
										</>
									)}
								</Form.List>

								<br />
								<hr />
								<br />
								<Form.Item
									style={{ marginBottom: "10px", marginTop: "20px" }}
									wrapperCol={{ offset: 4, span: 16 }}
								>
								</Form.Item>
							</TabPane>

							<TabPane tab="Education Information" key="9" disabled={isTabDisabled("9")}>
								<h2 className='text-center text-xl mt-3 mb-5 txt-color'>
									Education Information
								</h2>

								<div className='text-center'>
									<p className='text-red-500 text-base mb-4'>
										Please add education information using the button below
									</p>
								</div>

								<Form.List name='educations'>
									{(fields, { add, remove }) => (
										<>
											{fields.map(({ key, name, ...restField }) => (
												<EmployeeEducationForm
													key={key}
													name={name}
													remove={remove}
													restField={restField}
												/>
											))}
											<Form.Item
												style={{ marginBottom: "10px" }}
												wrapperCol={{
													offset: 4,
													span: 16,
												}}>
												<Button
													type='dashed'
													size='middle'
													style={{ color: "#fff", backgroundColor: "#2c3e50" }}
													onClick={() => add()}
													block
													icon={<PlusOutlined />}>
													Add Education Information
												</Button>
											</Form.Item>
										</>
									)}
								</Form.List>
								<br />
								<hr /> <hr /> <hr /> <hr />
								<br />
								<Form.Item
									style={{ marginBottom: "10px", marginTop: "20px" }}
									wrapperCol={{ offset: 4, span: 16 }}
								>
									<Button
										size='large'
										onClick={() => setLoader(true)}
										block
										type='primary'
										htmlType='submit'
										shape='round'
										loading={loader}
									>
										Add New Staff
									</Button>
								</Form.Item>
							</TabPane>
						</Tabs>
						<div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
							<Button onClick={handlePrevious} disabled={currentTab === '1'}>
								Previous
							</Button>
							<Button onClick={handleNext} disabled={currentTab === '9'}>
								Next
							</Button>
						</div>

					</Form>
				</div>
			</UserPrivateComponent>
		</Fragment>
	);
};

export default AddUser;
